import axios from 'axios';

export const containerEmptyLabelApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/container-empty-label`,
    headers: {
        'Content-Type': 'application/json'
    }
})